import { getDefaultTransition, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const ToggleVisibilityWidgetButtonContainer = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: ${Spacing.S8};
  right: ${Spacing.S8};
  z-index: ${zIndex.Tooltip};
  ${getDefaultTransition('opacity')}
`
